export enum RoleTypes {
	NONE = '',
	SUPER_ADMIN = 'SUPER_ADMIN',
	PRIMARY_ADMIN = 'PRIMARY_ADMIN',
	ADMIN = 'ADMIN',
	PARTNER_USER = 'PARTNER_USER',
	CLIENT_USER = 'CLIENT_USER',
}
